import {medicineReferences} from "../../../../hooks/medicineReferences.mjs";
import {hydrateMedicineDetails} from "../../../../hooks/medicineCatalogue.mjs";
import useMedicineFormDraft from "../../../../hooks/useMedicineFormDraft";
import MedicineDraftNotice from "../../../../components/adminPanel/shared/MedicineDraftNotice";
import MedicineResearchPanel from "../../../../components/adminPanel/shared/MedicineResearchPanel";
import SeoMedicinePanel from "../../../../components/adminPanel/shared/SeoMedicinePanel";
import {applyMedicineResearch} from "../../../../hooks/applyMedicineResearch";
import { useMedicineWorkspace } from "../../../../components/adminPanel/shared/MedicineWorkspace";
import { Link, useLocation } from "react-router-dom";
import MedicineSaveFeedback, { medicineSaveReceipt } from "../../../../components/adminPanel/shared/MedicineSaveFeedback";
import TranslationCatalogue from "../../../../components/adminPanel/shared/TranslationCatalogue";
import { TranslationFormActions } from "../../../../components/adminPanel/shared/TranslationControls";
import React from "react";
import MedicineTemplatePanel from "../../../../components/adminPanel/shared/MedicineTemplatePanel";
import Dialog from "@mui/material/Dialog";
import DialogContent from "@mui/material/DialogContent";
import DialogActions from "@mui/material/DialogActions";
import Button from "@mui/material/Button";
import TextField from "@mui/material/TextField";
import { useState } from "react";
import {
  Alert,
  Autocomplete,
  Checkbox,
  createFilterOptions,
  FormControl,
  FormControlLabel,
  Grid,
  IconButton,
  InputLabel,
  MenuItem,
  Select,
  Tooltip,
  Typography,
} from "@mui/material";
// Icon
import CancelIcon from "@mui/icons-material/Cancel";
import InfoIcon from "@mui/icons-material/Info";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import RemoveIcon from "@mui/icons-material/Remove";
import AddCircleIcon from "@mui/icons-material/AddCircle";
import AddIcon from "@mui/icons-material/Add";
import PhotoLibraryIcon from "@mui/icons-material/PhotoLibrary";
import BadgeIcon from "@mui/icons-material/Badge";
import TuneIcon from "@mui/icons-material/Tune";
import TravelExploreIcon from "@mui/icons-material/TravelExplore";
import ArticleIcon from "@mui/icons-material/Article";

import LoadingButton from "@mui/lab/LoadingButton";
import MedicineImageUpload from "../components/MedicineImageUpload";
import { useEffect } from "react";
import MedicineVideoUpload from "../components/MedicineVideoUpload";
import { useDispatch, useSelector } from "react-redux";
import {
  createMedicine,
  getCompanies,
  getDosages,
  getMedCategories,
  getMedicines,
  getAdminMedicineCatalogue,
  invalidateStorefrontMedicines,
  getSeoTags,
  uploadMedicineImages,
  uploadMedicineVideos,
} from "../../../../reduxToolkit/features/adminPanel/medicine";
import { Box } from "@mui/system";
import { PF, axiosInstance } from "../../../../config";
import { getSuppliers } from "../../../../reduxToolkit/features/adminPanel/supplier";
import AddCompanyDialog from "./AddCompanyDialog";
import AddCategoryDialog from "./AddCategoryDialog";
import AddSeoTags from "./AddSeoTags";
import AdditionalPage from "../components/AdditionalPage";
import { additionalPages } from "../data/additionalPages";
import ManageMedicineCategory from "../components/ManageMedicineCategory";
import { useRef } from "react";
import { resetGenericFileResponse } from "../../../../reduxToolkit/features/adminPanel/misc";
import { getNotification } from "../../../../reduxToolkit/features/adminPanel/notification";
import FileUpload from "../components/FileUpload";
import AddDosageDialog from "./AddDosageDialog";
import { LazyLoadImage } from "react-lazy-load-image-component";
import "react-lazy-load-image-component/src/effects/blur.css";
import LoadingBox from "../../../../components/misc/Loading";
import InfoTut from "../../../../components/InfoTut";
import FullScreenFormDialog from "../../../../components/adminPanel/shared/FullScreenFormDialog";
import MedicineFormSection from "../../../../components/adminPanel/shared/MedicineFormSection";
import { colors, radii } from "../../../../theme/designTokens";
// Limit options to show in autocomplete
const OPTIONS_LIMIT = 5;
const defaultFilterOptions = createFilterOptions();

const filterOptions = (options, state) => {
  return defaultFilterOptions(options, state).slice(0, OPTIONS_LIMIT);
};

export default function AddMedicineDialog({
  addMedicineDlg,
  setAddMedicineDlg,
  lang,
  langId,
  medListEn,
  page = false,
  onSaved,
  initialReceipt,
  sourceEntryId,
}) {
  const workspace = useMedicineWorkspace();
  const medicineBase = useLocation().pathname.split("/medicines")[0] + "/medicines";
  const [saveReceipt, setSaveReceipt] = useState(initialReceipt || null);
  const [saveError, setSaveError] = useState("");
  const initialSourceRef = useRef(null);
  const savingRef = useRef(false);
  const englishSelectionRequest = useRef(0);
  const submittedRef = useRef(null);
  const revisionRef = useRef(undefined);
  // Use Ref
  const additionalSectionBtnRef = useRef();
  // Use states
  const [formLoading, setFormLoading] = useState(false);
  const [researchMode,setResearchMode]=useState(false);
  const availabilityTouched=useRef(false);
  const aiGeneratedRef=useRef({});
  const [disableForm, setDisableForm] = useState(false);
  const [formError, setFormError] = useState(false);
  const [visible, setVisible] = useState(true);
  const [availability, setAvailability] = useState(0);
  // identification
  const [englishVariantId, setEnglishVariantId] = useState("");
  const fieldDisabled = lang !== "en" && !englishVariantId && !page;
  const [englishVariantLoading, setEnglishVariantLoading] = useState(false);
  const [genericBrand, setGenericBrand] = useState("");
  const [generic, setGeneric] = useState("");
  const [companyId, setCompanyId] = useState("");
  const [companyName, setCompanyName] = useState("");
  const [, setNonEngCompany] = useState(null);
  const [companyList, setCompanyList] = useState([]);
  const [companyListEn, setCompanyListEn] = useState([]);
  const [addCompanyDlg, setAddCompanyDlg] = useState(false);
  const [originator, setOriginator] = useState("");
  const [subCatId, setSubCatId] = useState([]);
  const [, setNonEngSubCat] = useState([]);
  const [, setSubCatName] = useState([]);
  const [subCatList, setSubCatList] = useState([]);
  const [subCatListEn, setSubCatListEn] = useState([]);
  const [catList, setCatList] = useState([]);
  const [catListEn, setCatListEn] = useState([]);
  const [manageCatDlg, setManageCatDlg] = useState(false);
  const [existingCatDlg, setExistingCatDlg] = useState(false);
  const [addCatDlg, setAddCatDlg] = useState(false);
  const [prescribed, setPrescribed] = useState(true);
  const [topSeller, setTopSeller] = useState(false);
  const [dealOfTheWeek, setDealOfTheWeek] = useState(false);
  const [isNew, setIsNew] = useState(false);
  const [stock, setStock] = useState(false);
  const [stockCount, setStockCount] = useState(0);
  const [images, setImages] = useState([]);
  const [videos, setVideos] = useState([]);

  // SEO
  const [metaKeyword, setMetaKeyword] = useState("");
  const [pageTitle, setPageTitle] = useState("");
  const [metaTitle, setMetaTitle] = useState("");
  const [metaDesc, setMetaDesc] = useState("");
  const [tags, setTags] = useState("");
  const [tagList, setTagList] = useState([]);
  const [, setNonEngTags] = useState([]);
  const [tagListEn, setTagListEn] = useState([]);
  const [addTagDlg, setAddTagDlg] = useState(false);

  // Variance
  const [variants, setVariants] = useState([]);
  const [addVariantSection, setAddVariantSection] = useState(0);
  const [dosageList, setDosageList] = useState([]);
  const [dosageListEn, setDosageListEn] = useState([]);
  const [addDosageDlg, setAddDosageDlg] = useState(false);
  const [variantDetectorId, setVariantDetectorId] = useState([]);
  const [dosageForm, setDosageForm] = useState([]);
  const [strength, setStrength] = useState([]);
  const [packTypes, setPackTypes] = useState([]);
  const [avgPriceOfOriginator, setAvgPriceOfOriginator] = useState([]);
  const [sellingPrice, setSellingPrice] = useState([]);
  const [discount, setDiscount] = useState([]);
  const [vipSellingPrice, setVipSellingPrice] = useState([]);
  const [weight, setWeight] = useState([]);
  const [showInFront, setShowInFront] = useState([]);
  const [
    companyPatientSellingPriceUpdated,
    setCompanyPatientSellingPriceUpdated,
  ] = useState([]);
  const [companyPatientSellingPriceOld, setCompanyPatientSellingPriceOld] =
    useState([]);
  const [companyMRP, setCompanyMRP] = useState([]);
  const [minimumOrderQty, setMinimumOrderQty] = useState([]);

  // Additional Section
  const [additionalSectionPrompt, setAdditionalSectionPrompt] = useState(false);
  const [addSectionName, setAddSectionName] = useState("");
  const [additionalSectionList, setAdditionalSectionList] = useState(() => additionalPages.map(section => ({ ...section })));

  // store
  const { companies, categories, seoTags, dosages } =
    useSelector((state) => state.medicine);

  // localData
  const localAdminData = JSON.parse(localStorage.getItem("adminLoginInfo"));
  const reviewSeed = workspace?.review?.data?.seedByLanguage?.[lang];
  const formDraft = useMedicineFormDraft({
    enabled: page, scope: workspace?.formDraftScope || 'new:manual', language: lang,
    ready: (page || companyList.length > 0) && !englishVariantLoading && (Boolean(reviewSeed) || !sourceEntryId || initialSourceRef.current === sourceEntryId),
    seed: reviewSeed, workspace,
    snapshot: { visible, availability, englishVariantId, genericBrand, generic, companyId, originator, subCatId, prescribed, topSeller, dealOfTheWeek, isNew, stock, stockCount, images, videos, metaKeyword, pageTitle, metaTitle, metaDesc, tags, variants, addVariantSection, variantDetectorId, dosageForm, strength, packTypes, avgPriceOfOriginator, sellingPrice, discount, vipSellingPrice, weight, showInFront, companyPatientSellingPriceUpdated, companyPatientSellingPriceOld, companyMRP, minimumOrderQty, additionalSectionList, companyName, researchMode, revision: revisionRef.current },
    setters: { visible: setVisible, availability: setAvailability, englishVariantId: setEnglishVariantId, genericBrand: setGenericBrand, generic: setGeneric, companyId: setCompanyId, originator: setOriginator, subCatId: setSubCatId, prescribed: setPrescribed, topSeller: setTopSeller, dealOfTheWeek: setDealOfTheWeek, isNew: setIsNew, stock: setStock, stockCount: setStockCount, images: setImages, videos: setVideos, metaKeyword: setMetaKeyword, pageTitle: setPageTitle, metaTitle: setMetaTitle, metaDesc: setMetaDesc, tags: setTags, variants: setVariants, addVariantSection: setAddVariantSection, variantDetectorId: setVariantDetectorId, dosageForm: setDosageForm, strength: setStrength, packTypes: setPackTypes, avgPriceOfOriginator: setAvgPriceOfOriginator, sellingPrice: setSellingPrice, discount: setDiscount, vipSellingPrice: setVipSellingPrice, weight: setWeight, showInFront: setShowInFront, companyPatientSellingPriceUpdated: setCompanyPatientSellingPriceUpdated, companyPatientSellingPriceOld: setCompanyPatientSellingPriceOld, companyMRP: setCompanyMRP, minimumOrderQty: setMinimumOrderQty, additionalSectionList: setAdditionalSectionList, companyName: setCompanyName, researchMode: setResearchMode, revision: value => { revisionRef.current = value; } },
  });

  const selectedCategories=React.useMemo(()=>subCatList.filter(row=>subCatId.includes(lang==='en'?row.fixedSubCatId:row.subCatDetectorId)),[subCatList,subCatId,lang]);

  // Use Effect
  const dispatch = useDispatch();
  useEffect(() => {
    if(page) return;
    dispatch(getCompanies());
    dispatch(getMedCategories());
    dispatch(getSuppliers());
    dispatch(getSeoTags());
    dispatch(getMedicines());
    dispatch(getDosages());
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);



  // Check Form Data
  useEffect(() => {
    if (
      genericBrand === "" ||
      (lang !== "en" && englishVariantId === "") ||
      companyId === "" ||
      subCatId.length < 1
    )
      setDisableForm(true);
    else if (variants.length > 0) {
      let counter = 0;
      variants.map((x, i) => x.dosageForm === "" && counter++);
      counter > 0 ? setDisableForm(true) : setDisableForm(false);
    } else setDisableForm(true);
  }, [
    addVariantSection,
    companyId,
    englishVariantId,
    genericBrand,
    lang,
    subCatId.length,
    variants,
  ]);

  // set company List
  useEffect(() => {
    if (lang !== "" && companies && companies.length > 0) {
      const C = {data: medicineReferences(companies, lang, "company")};
      C && setCompanyList(C.data);
      const CEn = companies.find((c) => c.lang === "en");
      CEn && setCompanyListEn(CEn.data);
    }
  }, [companies, lang]);

  // set Category List
  useEffect(() => {
    if (lang !== "" && categories && categories.length > 0) {
      const C = {data: medicineReferences(categories, lang, "category")};
      const CEn = categories.find((c) => c.lang === "en");
      // CEn && CEn.data && setCatListEn(CEn.data);
      let arr = [];
      if (C && C.data.length > 0) {
        setCatList(C.data);
        C.data.forEach((x, i) => {
          if (x.subCatList) {
            let arr2 = [];
            x.subCatList.forEach((y, j) => {
              let obj = {
                ...y,
                catName: x.catName,
              };
              arr2.push(obj);
            });
            arr = [...arr, ...arr2];
          }
          setSubCatList(arr);
        });
      } else setSubCatList([]);
      arr = [];
      if (CEn && CEn.data.length > 0) {
        setCatListEn(CEn.data);
        CEn.data.forEach((x, i) => {
          if (x.subCatList) {
            let arr2 = [];
            x.subCatList.forEach((y, j) => {
              let obj = {
                ...y,
                catName: x.catName,
              };
              arr2.push(obj);
            });
            arr = [...arr, ...arr2];
          }
          setSubCatListEn(arr);
        });
      } else setSubCatListEn([]);
    }
  }, [categories, lang]);

  // set Dosage List
  useEffect(() => {
    if (lang !== "" && dosages && dosages.length > 0) {
      const D = {data: medicineReferences(dosages, lang, "dosage")};
      if (D && D.data) setDosageList(D.data);
      else setDosageList([]);
      const DEn = dosages.find((d) => d.lang === "en");
      if (DEn && DEn.data) setDosageListEn(DEn.data);
      else setDosageListEn([]);
    }
  }, [dosages, lang]);

  // Set seo tag lists
  useEffect(() => {
    if (lang !== "" && seoTags && seoTags.length > 0) {
      const S = {data: medicineReferences(seoTags, lang, "tag")};
      const SEn = seoTags.find((s) => s.lang === "en");
      S && setTagList(S.data);
      SEn && SEn.data && setTagListEn(SEn.data);
    }
  }, [lang, seoTags]);

  // set Up additional Sections

  // Functions
  const handleAddMedicineDlgClose = () => {
    setAddMedicineDlg(false);
    setFormLoading(false);
    setDisableForm(false);
    setFormError(false);
    setVisible(true);
    setAvailability(0);
    setGenericBrand("");
    setGeneric("");
    setCompanyId("");
    setCompanyName("");
    setOriginator("");
    setSubCatId([]);
    setPrescribed(true);
    setStock(true);
    setStockCount(0);
    setImages([]);
    setVideos([]);
    setTags("");
    setAddVariantSection(0);
    setVariants([]);
    setVariantDetectorId([]);
    setDosageForm([]);
    setStrength([]);
    setPackTypes([]);
    setAvgPriceOfOriginator([]);
    setSellingPrice([]);
    setCompanyPatientSellingPriceUpdated([]);
    setCompanyPatientSellingPriceOld([]);
    setCompanyMRP([]);
    setShowInFront([]);
    setMinimumOrderQty([]);
    setAdditionalSectionList(additionalPages);
    setTopSeller(false);
    setDealOfTheWeek(false);
    setIsNew(false);
    // Non Eng
    setNonEngCompany(null);
    setNonEngSubCat([]);
    setNonEngTags([]);
    setEnglishVariantId("");
    dispatch(resetGenericFileResponse());
  };

  const handleCompanySelection = (e, newValue) => {
    if (newValue) {
      lang === "en"
        ? setCompanyId(newValue.fixedCompanyId)
        : setCompanyId(newValue.companyDetectorId);
      setCompanyName(newValue.companyName);
      setNonEngCompany(newValue);
    } else {
      setCompanyId("");setCompanyName("");setNonEngCompany(null);
    }
  };

  const handleCategory = () => {
    setManageCatDlg(true);
  };

  const handleCategorySelection = (e, newValue) => {
    let arrId = [];
    let arrName = [];
    newValue.forEach((x, i) => {
      lang === "en"
        ? arrId.push(x.fixedSubCatId)
        : arrId.push(x.subCatDetectorId);
      arrName.push(x.subCatName);
    });
    setSubCatId(arrId);
    setSubCatName(arrName);
  };

  const handleStockCount = (event) => {
    const result = event.target.value.replace(/\D/g, "");
    setStockCount(result);
  };
  // Variation
  useEffect(() => {
    const arr = [];
    dosageForm.map((x, i) => {
      const obj = {};
      if (lang !== "en") {
        obj.variantDetectorId = variantDetectorId[i];
      }
      obj.dosageForm = dosageForm[i];
      obj.strength = strength[i];
      obj.packTypes = packTypes[i];
      obj.avgPriceOfOriginator = avgPriceOfOriginator[i];
      obj.sellingPrice = sellingPrice[i];
      obj.discount = discount[i];
      obj.vipSellingPrice = vipSellingPrice[i];
      obj.weight = weight[i];
      obj.companyPatientSellingPriceUpdated =
        companyPatientSellingPriceUpdated[i];
      obj.companyPatientSellingPriceOld = companyPatientSellingPriceOld[i];
      obj.companyMRP = companyMRP[i];
      obj.showInFront = showInFront[i];
      obj.minimumOrderQty = minimumOrderQty[i];
      arr.push(obj);
      return 0;
    });
    setVariants(arr);
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [
    avgPriceOfOriginator,
    companyMRP,
    showInFront,
    companyPatientSellingPriceOld,
    companyPatientSellingPriceUpdated,
    variantDetectorId,
    dosageForm,
    minimumOrderQty,
    packTypes,
    sellingPrice,
    discount,
    strength,
    vipSellingPrice,
    weight,
  ]);

  const handleAddVariation = () => {
    setAddVariantSection(addVariantSection + 1);
    let arr = [...dosageForm];
    arr.push("");
    setDosageForm(arr);
    if (lang !== "en") {
      arr = [...variantDetectorId];
      arr.push("");
      setVariantDetectorId(arr);
    }
    arr = [...strength];
    arr.push("");
    setStrength(arr);
    arr = [...packTypes];
    arr.push("");
    setPackTypes(arr);
    arr = [...avgPriceOfOriginator];
    arr.push(0);
    setAvgPriceOfOriginator(arr);
    arr = [...sellingPrice];
    arr.push(0);
    setSellingPrice(arr);

    arr = [...discount];
    arr.push(0);
    setDiscount(arr);

    arr = [...vipSellingPrice];
    arr.push(0);
    setVipSellingPrice(arr);
    arr = [...companyPatientSellingPriceUpdated];
    arr.push(0);
    setCompanyPatientSellingPriceUpdated(arr);
    arr = [...companyPatientSellingPriceOld];
    arr.push(0);
    setCompanyPatientSellingPriceOld(arr);

    arr = [...companyMRP];
    arr.push(0);
    setCompanyMRP(arr);

    arr = [...showInFront];
    arr.push(true);
    setShowInFront(arr);

    arr = [...minimumOrderQty];
    arr.push(0);
    setMinimumOrderQty(arr);
    arr = [...weight];
    arr.push(0);
    setWeight(arr);
  };

  const handleDosageForm = (dosageName, i) => {
    let arr = [...dosageForm];
    arr[i] = dosageName;
    setDosageForm(arr);
  };
  const handleStrength = (e, i) => {
    let arr = [...strength];
    arr[i] = e.target.value;
    setStrength(arr);
  };
  const handlePackTypes = (e, i) => {
    let arr = [...packTypes];
    arr[i] = e.target.value;
    setPackTypes(arr);
  };
  const handleAvgPriceOfOriginator = (e, i) => {
    let arr = [...avgPriceOfOriginator];
    arr[i] = e.target.value.replace(/\D/g, "");
    setAvgPriceOfOriginator(arr);
  };
  const handleSellingPrice = (e, i) => {
    let arr = [...sellingPrice];
    arr[i] = e.target.value.replace(/\D/g, "");
    setSellingPrice(arr);
  };
  const handleVipSellingPrice = (e, i) => {
    let arr = [...vipSellingPrice];
    arr[i] = e.target.value.replace(/\D/g, "");
    setVipSellingPrice(arr);
  };

  const handleDiscount = (e, i) => {
    let arr = [...discount];
    arr[i] = e.target.value.replace(/\D/g, "");
    setDiscount(arr);
  };

  const handleCompanyPatientSellingPriceUpdated = (e, i) => {
    let arr = [...companyPatientSellingPriceUpdated];
    arr[i] = e.target.value.replace(/\D/g, "");
    setCompanyPatientSellingPriceUpdated(arr);
  };
  const handleCompanyPatientSellingPriceOld = (e, i) => {
    let arr = [...companyPatientSellingPriceOld];
    arr[i] = e.target.value.replace(/\D/g, "");
    setCompanyPatientSellingPriceOld(arr);
  };

  const handleCompanyMrp = (e, i) => {
    let arr = [...companyMRP];
    arr[i] = e.target.value.replace(/\D/g, "");
    setCompanyMRP(arr);
  };

  const handleShowInFront = (e, i) => {
    let arr = [...showInFront];
    arr[i] = e.target.checked;
    setShowInFront(arr);
  };

  const handleMinimumOrderQty = (e, i) => {
    let arr = [...minimumOrderQty];
    arr[i] = e.target.value.replace(/\D/g, "");
    setMinimumOrderQty(arr);
  };
  const handleWeight = (e, i) => {
    let arr = [...weight];
    arr[i] = e.target.value.replace(/\D/g, "");
    setWeight(arr);
  };

  const handleRemoveVariant = (i) => {
    let arr = [...dosageForm];
    arr.splice(i, 1);
    if (lang !== "en") {
      arr = [...variantDetectorId];
      arr.splice(i, 1);
      setVariantDetectorId(arr);
    }
    setDosageForm(arr);
    arr = [...strength];
    arr.splice(i, 1);
    setStrength(arr);
    arr = [...packTypes];
    arr.splice(i, 1);
    setPackTypes(arr);
    arr = [...avgPriceOfOriginator];
    arr.splice(i, 1);
    setAvgPriceOfOriginator(arr);

    arr = [...sellingPrice];
    arr.splice(i, 1);
    setSellingPrice(arr);

    arr = [...discount];
    arr.splice(i, 1);
    setDiscount(arr);

    arr = [...vipSellingPrice];
    arr.splice(i, 1);
    setVipSellingPrice(arr);
    arr = [...companyPatientSellingPriceUpdated];
    arr.splice(i, 1);
    setCompanyPatientSellingPriceUpdated(arr);
    arr = [...companyPatientSellingPriceOld];
    arr.splice(i, 1);
    setCompanyPatientSellingPriceOld(arr);

    arr = [...companyMRP];
    arr.splice(i, 1);
    setCompanyMRP(arr);

    arr = [...showInFront];
    arr.slice(i, 1);
    setShowInFront(arr);

    arr = [...minimumOrderQty];
    setMinimumOrderQty(arr);
    arr.splice(i, 1);
    arr = [...weight];
    arr.splice(i, 1);
    setWeight(arr);
    setAddVariantSection(addVariantSection - 1);
  };

  const handleTags = (e, newValue) => {
    newValue && setTags(newValue.fixedId);
    if (newValue) {
      let tagIdArr = [];
      newValue.forEach((x, i) => {
        lang === "en"
          ? tagIdArr.push(x.fixedId)
          : tagIdArr.push(x.tagDetectorId);
      });
      setTags(tagIdArr);
    }
  };

  // Additional Section
  const handleCreateAdditionalSection = () => {
    const obj = {
      sectionName: addSectionName,
      content: "",
      contentWithHtml: "",
    };
    const arr = [...additionalSectionList];
    arr.push(obj);
    setAdditionalSectionList(arr);
    setAddSectionName("");
    setAdditionalSectionPrompt(false);
  };

  function beginResearch() {
    if(researchMode)return;
    setResearchMode(true);
    if(!availabilityTouched.current)setAvailability('');
    if(workspace?.formRef)workspace.formRef.current.dirty=true;
  }

  function applyResearch({draft,selected,onlyEmpty,automatic=false}) {
    const result=applyMedicineResearch({draft,selected,onlyEmpty,automatic,generated:aiGeneratedRef.current,
      current:{originator,metaKeyword,metaTitle,pageTitle,metaDesc,companyId,subCatId,additionalSectionList,dosageForm,strength,packTypes,sellingPrice,discount,minimumOrderQty,weight,avgPriceOfOriginator,vipSellingPrice,companyPatientSellingPriceUpdated,companyPatientSellingPriceOld,companyMRP,showInFront,availability},
      lookups:{companies:medicineReferences(companies,'en','company'),categories:medicineReferences(categories,'en','category').flatMap(row=>row.subCatList||[]),dosages:medicineReferences(dosages,'en','dosage')},
      setters:{availability:setAvailability,originator:setOriginator,metaKeyword:setMetaKeyword,metaTitle:setMetaTitle,pageTitle:setPageTitle,metaDesc:setMetaDesc,companyId:setCompanyId,companyName:setCompanyName,subCatId:setSubCatId,subCatName:setSubCatName,additionalSectionList:setAdditionalSectionList,dosageForm:setDosageForm,strength:setStrength,packTypes:setPackTypes,addVariantSection:setAddVariantSection,avgPriceOfOriginator:setAvgPriceOfOriginator,sellingPrice:setSellingPrice,discount:setDiscount,vipSellingPrice:setVipSellingPrice,companyPatientSellingPriceUpdated:setCompanyPatientSellingPriceUpdated,companyPatientSellingPriceOld:setCompanyPatientSellingPriceOld,companyMRP:setCompanyMRP,minimumOrderQty:setMinimumOrderQty,weight:setWeight,showInFront:setShowInFront}});
    aiGeneratedRef.current=result.generatedValues;
    if(workspace?.formRef)workspace.formRef.current.dirty=true;
    return result;
  }

  // Add Medicine Final Button
  const handleAddMedicine = async (translationIntent, mediaOverride) => {
    if (savingRef.current) return;
    if (workspace?.review && translationIntent?.scope) { setSaveError('Save this reviewed language with Add Medicine first.'); return; }
    savingRef.current = true;
    setFormLoading(true);
    setSaveError("");
    setSaveReceipt(null);
    try {
    let obj = {};
    obj.images = (mediaOverride?.images || images).map(item => ({ ...item }));
    obj.videos = (mediaOverride?.videos || videos).map(item => ({ ...item }));
    obj.genericBrand = genericBrand;
    obj.generic = generic;
    obj.originator = originator;
    obj.companyId = companyId;
    obj.subCatId = subCatId;
    obj.variants = variants;
    obj.metaKeyword = metaKeyword;
    obj.pageTitle = pageTitle;
    obj.metaTitle = metaTitle;
    obj.metaDesc = metaDesc;
    obj.tags = tags;
    obj.additionalSectionList = mediaOverride?.additionalSections || additionalSectionList;
    obj.visible = visible;
    obj.availability = availability === "" ? null : availability;
    obj.prescribed = prescribed;
    obj.topSeller = topSeller;
    obj.dealOfTheWeek = dealOfTheWeek;
    obj.isNew = isNew;
    obj.stock = stock;
    obj.stockCount = stockCount;

    // Non Eng
    obj.englishVariantId = englishVariantId;

    const uploads = [];
    // Img
    obj.images.forEach((x, i) => {
      if (typeof x.file !== "undefined") {
        let data = new FormData();
        const ext = x.file.name.split(".");
        const filename =
          Date.now() +
          "-" +
          genericBrand
            .replace(/[^a-z0-9_]+/gi, "-")
            .replace(/^-|-$/g, "")
            .toLowerCase() +
          "-medicine-pic." +
          ext.slice(-1);
        data.append("name", filename);
        data.append("medicineImg", x.file);
        obj.images[i].src = filename;
        uploads.push(dispatch(uploadMedicineImages(data)).unwrap());
      }
    });

    // Vid
    obj.videos.forEach((x, i) => {
      if (typeof x.file !== "undefined") {
        if (x.externalLink) {
          obj.videos[i].src = x.file;
        } else {
          let data = new FormData();
          const ext = x.file.name.split(".");
          const filename =
            Date.now() +
            "-" +
            genericBrand
              .replace(/[^a-z0-9_]+/gi, "-")
              .replace(/^-|-$/g, "")
              .toLowerCase() +
            "-medicine-vid." +
            ext.slice(-1);
          data.append("name", filename);
          data.append("medicineVid", x.file);
          obj.videos[i].src = filename;
          uploads.push(dispatch(uploadMedicineVideos(data)).unwrap());
        }
      }
    });
    let arr = [];
    arr.push(obj);
    await Promise.all(uploads);
    const result = await dispatch(
      createMedicine({
        creatorId: localAdminData._id,
        lang,
        data: arr,
        langId,
        ...(workspace?.review ? { seoReview: formDraft.seoReview() } : {}),
        ...(translationIntent?.scope ? { translationIntent } : {}),
      })
    ).unwrap();

    if (result.failed) throw new Error(result.message || "Medicine could not be saved.");
    revisionRef.current = result.revision;
    const receipt = medicineSaveReceipt(obj, submittedRef.current, lang, translationIntent, true);
    submittedRef.current = JSON.parse(JSON.stringify(obj));
    setSaveReceipt(receipt);
    setImages(obj.images.map(({ file, ...image }) => image));
    setVideos(obj.videos.map(({ file, ...video }) => video));
    dispatch(getNotification());
    dispatch(invalidateStorefrontMedicines());
    const refreshed=await dispatch(page ? getAdminMedicineCatalogue({force:true}) : getMedicines());
    const acknowledged=refreshed.meta.requestStatus==='fulfilled'?receipt:{...receipt,warning:"Your medicine was added. The list could not be refreshed; use Refresh list after returning."};
    setSaveReceipt(acknowledged);
    formDraft.saved(result);
    onSaved?.(result, acknowledged);
    } catch (error) {
      setSaveError(error.message || "Medicine could not be saved. Your changes are still here.");
    } finally {
      savingRef.current = false;
      setFormLoading(false);
    }
  };

  // handle English Variant
  const handleEnglishVariant = async (e, newValue) => {
    const request=++englishSelectionRequest.current;
    setEnglishVariantLoading(true);
    if (newValue) {
      let M = medListEn.find(m => m._id === newValue._id);
      if (!M) { setEnglishVariantLoading(false); return; }
      try {const response=await axiosInstance.get(`/api/medicine/details/${M._id}?lang=en&include=variants`);if(request!==englishSelectionRequest.current)return;M=hydrateMedicineDetails(M,response.data);}
      catch {if(request!==englishSelectionRequest.current)return;setSaveError("The English medicine could not be loaded. Your current fields were preserved.");setEnglishVariantLoading(false);return;}
      setEnglishVariantId(M.fixedMedicineId);
      if (M) {
        setOriginator(M.originator || '');
        // Company Selector
        const C = companyList.find((c) => c.companyDetectorId === M.companyId);
        if (C) {
          setNonEngCompany(C);
          setCompanyId(C.companyDetectorId);
          setCompanyName(C.companyName);
        }
        // SubCategory Selector
        if (M.subCats && M.subCats.length > 0) {
          let ScArr = [];
          M.subCats.map((x, i) => {
            const Sc = subCatList.find(
              (sc) => sc.subCatDetectorId === x.subCatId
            );
            if (Sc) ScArr.push(Sc);
            return 0;
          });
          let arrId = [];
          let arrName = [];
          ScArr.forEach((x, i) => {
            arrId.push(x.subCatDetectorId);
            arrName.push(x.subCatName);
          });
          setSubCatId(arrId);
          setSubCatName(arrName);
          setNonEngSubCat([...ScArr]);
        }
        // Set checklists
        setVisible(M.visible);
        setAvailability(M.availability || 0);
        setPrescribed(M.prescribed ?? true);
        setTopSeller(M.topSeller);
        setDealOfTheWeek(M.dealOfTheWeek);
        setIsNew(M.new);
        if (M.stock > 0) {
          setStock(true);
          setStockCount(M.stock);
        }

        setImages(M.image || []);
        setVideos(M.video || []);

        // Set Variant
        if (M.variantInfo && M.variantInfo.length > 0) {
          setAddVariantSection(M.variantInfo.length);
          let variantDetectorArr = [];
          let dosageArr = [];
          let strengthArr = [];
          let packTypeArr = [];
          let avgPriceArr = [];
          let sellingArr = [];
          let discountArr = [];
          let vipSellingArr = [];
          let companyPatientUpdatedArr = [];
          let companyPatientOldArr = [];
          let mrpArr = [];
          let showInFrontArr = [];
          let moqArr = [];
          let weightArr = [];
          M.variantInfo.map((x, i) => {
            variantDetectorArr[i] = x.fixedVariantId;
            dosageArr[i] = x.dosageForm;

            // modify strength
            let str = x.strength;
            if (lang === "cn") str = x.strength.replace("mg", "毫克");
            else if (lang === "ru") str = x.strength.replace("mg", "мг");
            strengthArr[i] = str;

            // modify packTypes
            let pt = x.packTypes;
            if (lang === "cn") {
              if (x.packTypes.includes("Strip")) {
                pt = x.packTypes.replace("Strip", "跳閘");
              } else if (x.packTypes.includes("Pot")) {
                pt = x.packTypes.replace("Pot", "鍋");
              } else if (x.packTypes.includes("Vial")) {
                pt = x.packTypes.replace("Vial", "小瓶");
              } else if (x.packTypes.includes("Ampoules")) {
                pt = x.packTypes.replace("Ampoules", "安瓿");
              } else if (x.packTypes.includes("Tube")) {
                pt = x.packTypes.replace("Tube", "管子");
              } else if (x.packTypes.includes("Box")) {
                pt = x.packTypes.replace("Box", "盒");
              } else if (x.packTypes.includes("Sachets")) {
                pt = x.packTypes.replace("Sachets", "香囊");
              }
            } else if (lang === "ru") {
              if (x.packTypes.includes("Strip")) {
                pt = x.packTypes.replace("Strip", "Полоса");
              } else if (x.packTypes.includes("Pot")) {
                pt = x.packTypes.replace("Pot", "горшок");
              } else if (x.packTypes.includes("Vial")) {
                pt = x.packTypes.replace("Vial", "Флакон");
              } else if (x.packTypes.includes("Ampoules")) {
                pt = x.packTypes.replace("Ampoules", "Ампулы");
              } else if (x.packTypes.includes("Tube")) {
                pt = x.packTypes.replace("Tube", "Трубка");
              } else if (x.packTypes.includes("Box")) {
                pt = x.packTypes.replace("Box", "коробка");
              } else if (x.packTypes.includes("Sachets")) {
                pt = x.packTypes.replace("Sachets", "Пакетики");
              }
            }
            packTypeArr[i] = pt;

            avgPriceArr[i] = x.avgPriceOfOriginator;
            sellingArr[i] = x.sellingPrice;
            discountArr[i] = x.discount;
            vipSellingArr[i] = x.vipSellingPrice;
            companyPatientUpdatedArr[i] = x.companyPatientSellingPriceUpdated;
            companyPatientOldArr[i] = x.companyPatientSellingPriceOld;
            mrpArr[i] = x.companyMRP;
            showInFrontArr[i] = x.showInFront;
            moqArr[i] = x.minimumOrderQty;
            weightArr[i] = x.weight;
            return 0;
          });
          setVariantDetectorId(variantDetectorArr);
          setDosageForm(dosageArr);
          setStrength(strengthArr);
          setPackTypes(packTypeArr);
          setAvgPriceOfOriginator(avgPriceArr);
          setSellingPrice(sellingArr);
          setDiscount(discountArr);
          setVipSellingPrice(vipSellingArr);
          setCompanyPatientSellingPriceUpdated(companyPatientUpdatedArr);
          setCompanyPatientSellingPriceOld(companyPatientOldArr);
          setCompanyMRP(mrpArr);
          setShowInFront(showInFrontArr);
          setMinimumOrderQty(moqArr);
          setWeight(weightArr);
        }

        // Set Tags
        if (M.tagsArr && M.tagsArr.length > 0) {
          let nonTArr = [];
          let tArr = [];
          M.tagsArr.map((x, i) => {
            const T = tagList.find((t) => t.tagDetectorId === x.fixedId);
            if (T) {
              nonTArr.push(T);
              tArr.push(T.tagDetectorId);
            }
            return 0;
          });
          setNonEngTags([...nonTArr]);
          setTags([...tArr]);
        }
      }
    } else {
      setNonEngCompany(null);
      setNonEngSubCat([]);
      setEnglishVariantId("");
      setVisible(true);
      setAvailability(0);
      setPrescribed(true);
      setTopSeller(false);
      setDealOfTheWeek(false);
      setIsNew(false);
      setStock(false);
      setStockCount(0);
      setAddVariantSection(0);
      setVariants([]);
      setVariantDetectorId([]);
      setDosageForm([]);
      setStrength([]);
      setPackTypes([]);
      setAvgPriceOfOriginator([]);
      setSellingPrice([]);
      setCompanyPatientSellingPriceUpdated([]);
      setCompanyPatientSellingPriceOld([]);
      setCompanyMRP([]);
      setShowInFront([]);
      setMinimumOrderQty([]);
      setNonEngTags([]);
      setImages([]);
      setVideos([]);
    }
    setEnglishVariantLoading(false);
  };

  // Handle Dosage Form
  const handleDosageSelect = (e, newValue, i) => {
    handleDosageForm(newValue ? (lang !== "en" ? newValue.dosageDetectorId : newValue.fixedDosageId) : "", i);
  };

  const getEngCompany = (companyName) => {
    const C = companyList.find((c) => c.companyName === companyName);
    if (C && C.companyDetectorId) {
      const CEn = companyListEn.find(
        (c) => c.fixedCompanyId === C.companyDetectorId
      );
      if (CEn && CEn.companyName) return CEn.companyName;
    }
    return "";
  };

  useEffect(() => {
    if (workspace?.review || !sourceEntryId || lang === "en" || initialSourceRef.current === sourceEntryId) return;
    const source = medListEn.find(item => String(item._id) === sourceEntryId);
    if (!source) return;
    const expectedCompanies = medicineReferences(companies, lang, "company");
    const expectedCategories = medicineReferences(categories, lang, "category");
    const expectedSubcats = expectedCategories.reduce((count, category) => count + (category.subCatList?.length || 0), 0);
    const expectedTags = medicineReferences(seoTags, lang, "tag");
    if (companyList.length !== expectedCompanies.length || subCatList.length !== expectedSubcats || tagList.length !== expectedTags.length) return;
    initialSourceRef.current = sourceEntryId;
    handleEnglishVariant(null, source);
  // The one-time source guard prevents background reference refreshes from overwriting input.
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [sourceEntryId, lang, medListEn, companies, categories, seoTags, companyList, subCatList, tagList]);

  const getEngSubCat = (subCatName) => {
    const Sc = subCatList.find((sc) => sc.subCatName === subCatName);
    if (Sc && Sc.subCatDetectorId) {
      const ScEn = subCatListEn.find(
        (sc) => sc.fixedSubCatId === Sc.subCatDetectorId
      );
      if (ScEn && ScEn.subCatName) {
        return ScEn.subCatName;
      }
    }
    return "";
  };

  const getEngCat = (catName) => {
    const C = catList.find((c) => c.catName === catName);
    if (C && C.categoryDetectorId) {
      const CEn = catListEn.find((c) => c.fixedCatId === C.categoryDetectorId);
      if (CEn && CEn.catName) {
        return CEn.catName;
      }
    }
    return "";
  };

  const getEngDosage = (dosageName) => {
    const D = dosageList.find((d) => d.dosageName === dosageName);
    if (D && D.dosageDetectorId) {
      const DEn = dosageListEn.find(
        (d) => d.fixedDosageId === D.dosageDetectorId
      );
      if (DEn && DEn.dosageName) {
        return DEn.dosageName;
      }
    }
    return "";
  };

  const getDosageName = (dosageId) => {
    let dosageName = "";
    const D = dosageList.find((d) =>
      (lang !== "en" ? d.dosageDetectorId : d.fixedDosageId) === dosageId
    );
    if (D && D.dosageName) dosageName = D.dosageName;
    if (lang !== "en") {
      const DEn = dosageListEn.find((d) => d.fixedDosageId === dosageId);
      if (DEn && DEn.dosageName)
        dosageName = dosageName + " - " + DEn.dosageName;
    }
    return dosageName;
  };

  const getEngTag = (tagName) => {
    const T = tagList.find((t) => t.tagName === tagName);
    if (T && T.tagDetectorId) {
      const TEn = tagListEn.find((t) => t.fixedId === T.tagDetectorId);
      if (TEn && TEn.tagName) {
        return TEn.tagName;
      }
    }
    return "";
  };

  // ! translate
  const [siteLang, setSiteLang] = useState("en");
  // Local Store
  const localLangData = JSON.parse(localStorage.getItem("lang"));
  // Store
  const { langs, activeLang } = useSelector((state) => state.misc);
  const [langSettings1, setLangSettings1] = useState([]);
  const [langSettings2, setLangSettings2] = useState([]);
  const [langSettings3, setLangSettings3] = useState([]);
  const [langSettings4, setLangSettings4] = useState([]);
  const [langSettings5, setLangSettings5] = useState([]);
  const title1 = "Add Medicine Dialog";
  const title2 = "Misc Words";
  const title3 = "Manage Medicine";
  const title4 = "Add Company Dialog";
  const title5 = "Add Sub Category Dialog";

  useEffect(() => {
    if (langs && langs.length > 0 && siteLang !== "" && lang !== "") {
      const LEnShared = langs.find((l) => l.langCode === "en");
      // Falls back to the English section whenever the language's own
      // section is missing or empty — not just when the whole language
      // has zero langSettings — so a partially-translated language (e.g.
      // one missing just this section) still gets usable templates
      // instead of silently filling nothing.
      const findSectionWithFallback = (langCode, title) => {
        const L = langs.find((l) => l.langCode === langCode);
        let section = ((L && L.langSettings) || []).find((l) => l._title === title);
        if (!section || !section.data || section.data.length === 0) {
          section = ((LEnShared && LEnShared.langSettings) || []).find(
            (l) => l._title === title
          );
        }
        return section;
      };

      const A = findSectionWithFallback(siteLang, title1);
      if (A) setLangSettings1(A.data);
      const B = findSectionWithFallback(siteLang, title2);
      if (B) setLangSettings2(B.data);
      const C = findSectionWithFallback(siteLang, title3);
      if (C) setLangSettings3(C.data);
      const D = findSectionWithFallback(siteLang, title4);
      if (D) setLangSettings4(D.data);
      const E = findSectionWithFallback(siteLang, title5);
      if (E) setLangSettings5(E.data);
    }
  }, [siteLang, langs, lang]);

  const translate1 = (String) => translation(String, title1, 1);
  const translate3 = (String) => translation(String, title3, 3);
  const translate4 = (String) => translation(String, title4, 4);
  const translate5 = (String) => translation(String, title5, 5);

  const translation = (String, title, index) => {
    let translation = "";
    let settings = [];
    if (index === 1) {
      settings = langSettings1;
    } else if (index === 2) {
      settings = langSettings2;
    } else if (index === 3) {
      settings = langSettings3;
    } else if (index === 4) {
      settings = langSettings4;
    } else if (index === 5) {
      settings = langSettings5;
    }
    const T = settings.find((ls) => ls.title === String);
    if (T && T.value) translation = T.value;
    else {
      let arr = [];
      if (langs && langs.length > 0 && siteLang !== "") {
        const LEn = langs.find((l) => l.langCode === "en");
        if (LEn && LEn.langSettings && LEn.langSettings.length > 0)
          arr = LEn.langSettings;
        const S = arr.find((l) => l._title === title);
        if (S) {
          const T = S.data.find((ls) => ls.title === String);
          if (T && T.value) translation = T.value;
        }
      }
    }
    return translation || String;
  };
  useEffect(() => {
    if (activeLang && activeLang.langCode) {
      setSiteLang(activeLang.langCode);
    } else {
      if (localLangData) {
        setSiteLang(localLangData.langCode);
      }
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [activeLang]);
  // ! translate

  //! Translate
  // Store
  const { langArrFromClientSide } = useSelector((state) => state.misc);
  const translate0 = (String) => {
    let translation = "";
    if (langArrFromClientSide && langArrFromClientSide.length > 0) {
      const T = langArrFromClientSide.find((l) => l.title === String);
      if (T && T.value) {
        let obj = { ...T };
        if (T.value === "") obj.value = T.title;
        translation = T.value;
      } else if (T === undefined) translation = String;
    }
    return translation || String;
  };
  //! Translate

  return (
    <FullScreenFormDialog
      page={page}
      busy={formLoading}
      savedAt={saveReceipt?.at}
      open={addMedicineDlg}
      onClose={() => setAddMedicineDlg(false)}
      onCloseIcon={handleAddMedicineDlgClose}
      title={translate3("Add Medicine")}
      subtitle={`New medicine · ${lang.toUpperCase()}`}
      headerActions={
        <LoadingButton
          loading={formLoading ? true : false}
          loadingPosition="end"
          endIcon={<AddIcon />}
          color="primary"
          variant="contained"
          onClick={handleAddMedicine}
          disabled={disableForm || formLoading || !formDraft.initialized}
          sx={{ minWidth: { xs: 96, sm: 160 } }}
        >
          {translate3("Add Medicine")}
        </LoadingButton>
      }
    >
      <Box sx={{ bgcolor: colors.paperTint, m: 0, p: { xs: 0, sm: 2 } }}>
        {workspace?.review && <Alert severity="info" sx={{ mb: 2 }}>Review these generated fields in the normal medicine form. Add Medicine saves only this language. Your unsaved changes remain available when switching language tabs or reloading.</Alert>}
        {reviewSeed?.requiresEnglishSave && <Alert severity="warning" sx={{ mb: 2 }}>Save the English medicine first to link this language version.<Button onClick={() => workspace.changeLanguage('en')}>Open English draft</Button></Alert>}
        <MedicineDraftNotice draft={formDraft} reviewSeed={reviewSeed} />
        {sourceEntryId && lang !== "en" && <Alert severity="info" sx={{ mb: 2 }}>
          This medicine has no version in this language yet. Its English source is selected below. You can add this version manually, or <Link to={`${medicineBase}/en/${sourceEntryId}/edit`} onClick={event => { if (workspace && !workspace.confirmLeave()) event.preventDefault(); }}>return to English to request a translation</Link>. Nothing is translated or published until you submit an action.
        </Alert>}
        <MedicineSaveFeedback receipt={saveReceipt} error={saveError} />
        {disableForm && <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>To save, enter a brand, select a company and subcategory, and add a variation with a dosage form.</Typography>}
        {lang === "en" && <MedicineResearchPanel generic={generic} brand={genericBrand} setGeneric={setGeneric} setBrand={setGenericBrand} onApply={applyResearch} onStart={beginResearch} disabled={formLoading} hasVariants={[dosageForm,strength,packTypes,sellingPrice,discount,minimumOrderQty,weight,avgPriceOfOriginator,vipSellingPrice,companyPatientSellingPriceUpdated,companyPatientSellingPriceOld,companyMRP].some(values=>values.some(value=>value!==undefined&&value!==null&&String(value).trim()!==''))} readyToApply={Array.isArray(companies)&&Array.isArray(categories)&&Array.isArray(dosages)} />}
        {lang === "en" && !workspace?.review && <TranslationFormActions
          sourceId={undefined} disabled={disableForm || formLoading} onSave={handleAddMedicine}

        />}
        <MedicineTemplatePanel generic={generic} brand={genericBrand} language={lang}
          current={{metaKeyword,pageTitle,metaTitle,metaDesc,additionalSectionList}}
          setters={{metaKeyword:setMetaKeyword,pageTitle:setPageTitle,metaTitle:setMetaTitle,metaDesc:setMetaDesc,additionalSectionList:setAdditionalSectionList}}
          details={{originator,companyId,companyName,variantArr:dosageForm.map((value,index)=>({dosageForm:value,strength:strength[index] || '',packTypes:packTypes[index] || '',minimumOrderQty:minimumOrderQty[index] || ''}))}}
          variables={{company_name:companyName || '',originator_brand:originator || '',strengths:[...new Set(strength.filter(Boolean))].join(', '),dosage_form:[...new Set(dosageForm.map(getDosageName).filter(Boolean))].join(', '),pack_types:[...new Set(packTypes.filter(Boolean))].join(', '),minimum_order_quantity:[...new Set(minimumOrderQty.filter(Boolean))].join(', ')}}
          automatic={page && formDraft.initialized && !researchMode && !workspace?.review} disabled={formLoading || !formDraft.initialized} />
        <SeoMedicinePanel generic={generic} brand={genericBrand} language={lang} current={{metaKeyword,pageTitle,metaTitle,metaDesc,additionalSectionList}} setters={{metaKeyword:setMetaKeyword,pageTitle:setPageTitle,metaTitle:setMetaTitle,metaDesc:setMetaDesc,additionalSectionList:setAdditionalSectionList}} disabled={formLoading} />
        {lang !== "en" && <TranslationCatalogue language={lang} compact />}
        <Grid container spacing={3}>
          <Grid item xs={12}>
            <MedicineFormSection sectionId="medicine-media" icon={<PhotoLibraryIcon />} title={translate1("Media")}>
              <Grid container spacing={2.5}>
                <Grid item xs={12} sm={6}>
                  <MedicineImageUpload
                    images={images}
                    onTranslate={undefined}
                    disableTranslation={disableForm || formLoading}
                    setImages={setImages}
                    translate1={translate1}
                  />
                </Grid>
                <Grid item xs={12} sm={6}>
                  <MedicineVideoUpload videos={videos} setVideos={setVideos} onTranslate={undefined} disableTranslation={disableForm || formLoading} />
                </Grid>
              </Grid>
            </MedicineFormSection>
          </Grid>
          {/* Identification */}
          <Grid item xs={12}>
            <MedicineFormSection sectionId="medicine-identification" icon={<BadgeIcon />} title={translate1("Identification")}>
            <Grid container spacing={2.5}>
          <Grid item xs={lang !== "en" ? 6 : 12}>
            <TextField
              label={translate1("Generic Brand")}
              value={genericBrand}
              onChange={(e) => {
                setGenericBrand(e.target.value);
                setFormError(false);
              }}
              fullWidth
              variant="outlined"
              required
              error={
                lang !== "en" && !fieldDisabled && genericBrand.length < 1
                  ? true
                  : formError
                  ? true
                  : false
              }
              helperText={
                formError && (
                  <Typography variant="body2" color="error">
                    {translate3("Already Exist")}
                  </Typography>
                )
              }

            />
          </Grid>
          {lang !== "en" && (
            <Grid item xs={6}>
              <Autocomplete
                onChange={(e, newValue) => handleEnglishVariant(e, newValue)}
                disabled={Boolean(workspace?.review)}
                value={medListEn.find(item => item.fixedMedicineId === englishVariantId) || null}
                isOptionEqualToValue={(option, value) => option._id === value._id}
                disablePortal
                // disabled
                options={medListEn}
                filterOptions={filterOptions}
                getOptionLabel={(option) => option.genericBrand}
                renderOption={(props, option) => (
                  <Box
                    component="li"
                    sx={{ "& > img": { mr: 2, flexShrink: 0 } }}
                    {...props}
                  >
                    <LazyLoadImage
                      // <img
                      // loading="lazy"
                      src={
                        option.image.length > 0
                          ? option.image
                              .find((i) => i.default)
                              .src.includes("http")
                            ? option.image.find((i) => i.default).src
                            : PF +
                              "adminPanel/medicines/img/" +
                              option.image.find((i) => i.default).src
                          : "https://www.daveraine.com/img/products/no-image.jpg"
                      }
                      effect="blur"
                      alt="genericBrand"
                      style={{
                        objectFit: "contain",
                        width: "40px",
                        height: "30px",
                      }}
                    />{" "}
                    {option.genericBrand}
                  </Box>
                )}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    label={translate1("English Variant")}
                    variant="outlined"
                    size="small"
                    fullWidth
                  />
                )}
              />
            </Grid>
          )}
          {englishVariantLoading ? (
            <Grid item xs={12}>
              <LoadingBox w={"100%"} h={"100%"} />
            </Grid>
          ) : (
            <>
              <Grid item xs={12}>
                <TextField
                  label={translate1("Generic ")}
                  value={generic}
                  onChange={(e) => setGeneric(e.target.value)}
                  fullWidth
                  variant="outlined"
                  error={
                    lang !== "en" && !fieldDisabled && generic.length < 1
                      ? true
                      : false
                  }
                  disabled={fieldDisabled}
                />
              </Grid>
              <Grid item xs={12}>
                <TextField
                  label={translate1("Originator")}
                  value={originator}
                  onChange={(e) => setOriginator(e.target.value)}
                  fullWidth
                  variant="outlined"
                  disabled={fieldDisabled}
                  error={
                    lang !== "en" && !fieldDisabled && originator.length < 1
                      ? true
                      : false
                  }
                />
              </Grid>
              {!fieldDisabled && (
                <Grid item xs={12}>
                  <Grid
                    container
                    spacing={0}
                    justifyContent="space-between"
                    alignItems="center"
                  >
                    <Grid item xs={11} xl={11.75}>
                      <Autocomplete
                        onChange={(e, newValue) =>
                          handleCompanySelection(e, newValue)
                        }
                        disablePortal
                        value={companyList.find(row=>(lang==='en'?row.fixedCompanyId:row.companyDetectorId)===companyId)||null}
                        isOptionEqualToValue={(option,value)=>option.fixedCompanyId===value.fixedCompanyId}
                        disabled={fieldDisabled}
                        options={companyList}
                        filterOptions={filterOptions}
                        getOptionLabel={(option) =>
                          option.companyName +
                          (lang !== "en"
                            ? "(" + getEngCompany(option.companyName) + ")"
                            : "")
                        }
                        renderOption={(props, option) => (
                          <Box
                            component="li"
                            sx={{ "& > img": { mr: 2, flexShrink: 0 } }}
                            {...props}
                          >
                            <img
                              loading="lazy"
                              src={
                                option.companyLogo.includes("http")
                                  ? option.companyLogo
                                  : PF +
                                    "adminPanel/companies/" +
                                    option.companyLogo
                              }
                              alt="admins"
                              style={{
                                objectFit: "contain",
                                width: "40px",
                                height: "30px",
                              }}
                            />
                            {option.companyName}{" "}
                            {lang !== "en"
                              ? "(" + getEngCompany(option.companyName) + ")"
                              : ""}
                          </Box>
                        )}
                        renderInput={(params) => (
                          <TextField
                            {...params}
                            label={translate1("Local Company")}
                            required
                            variant="outlined"
                            size="small"
                            fullWidth
                            error={
                              lang !== "en" && !fieldDisabled && !companyId
                                ? true
                                : false
                            }
                          />
                        )}
                      />
                    </Grid>
                    <Grid item xs={1} xl={0.25}>
                      <Tooltip
                        title={translate4("Add Company")}
                        arrow
                        placement="top"
                      >
                        <IconButton
                          size="small"
                          sx={{ mt: 1 }}
                          onClick={() => setAddCompanyDlg(true)}
                        >
                          <AddCircleIcon color="success" />
                        </IconButton>
                      </Tooltip>
                      <AddCompanyDialog
                        addCompanyDlg={addCompanyDlg}
                        setAddCompanyDlg={setAddCompanyDlg}
                        lang={lang}
                        companyListEn={companyListEn}
                      />
                    </Grid>
                  </Grid>
                </Grid>
              )}
              {!fieldDisabled && (
                <Grid item xs={12}>
                  <Grid container spacing={0} justifyContent="space-between">
                    <Grid item xs={11} xl={11.75}>
                      <Autocomplete
                        onChange={(e, newValue) =>
                          handleCategorySelection(e, newValue)
                        }
                        disablePortal
                        multiple
                        value={selectedCategories}
                        isOptionEqualToValue={(option,value)=>option.fixedSubCatId===value.fixedSubCatId}
                        disabled={fieldDisabled}
                        options={subCatList}
                        filterOptions={filterOptions}
                        getOptionLabel={(option) =>
                          option.subCatName + "( " + option.catName + " )"
                        }
                        renderOption={(props, option) => (
                          <Box
                            component="li"
                            sx={{ "& > img": { mr: 2, flexShrink: 0 } }}
                            {...props}
                          >
                            {option.subCatName}{" "}
                            {lang !== "en" &&
                              "-" + getEngSubCat(option.subCatName)}
                            ({option.catName}
                            {lang !== "en" && "-" + getEngCat(option.catName)})
                          </Box>
                        )}
                        renderInput={(params) => (
                          <TextField
                            {...params}
                            label={translate1("Sub Category")}
                            required
                            variant="outlined"
                            size="small"
                            fullWidth
                            error={
                              lang !== "en" &&
                              !fieldDisabled &&
                              subCatId.length < 1
                                ? true
                                : false
                            }
                          />
                        )}
                      />
                    </Grid>
                    <Grid item xs={1} xl={0.25}>
                      <Tooltip
                        title={translate5("Add Sub Category")}
                        arrow
                        placement="top"
                      >
                        <IconButton
                          size="small"
                          sx={{ mt: 1 }}
                          onClick={handleCategory}
                        >
                          <AddCircleIcon color="success" />
                        </IconButton>
                      </Tooltip>
                      <AddCategoryDialog
                        lang={lang}
                        addCategoryDlg={addCatDlg}
                        setAddCategoryDlg={setAddCatDlg}
                        categoryListEn={catListEn}
                      />
                      {/* Select sub cat manage option */}
                      <Dialog
                        open={manageCatDlg}
                        onClose={() => setManageCatDlg(false)}
                        aria-labelledby={"manage-category"}
                      >
                        <DialogContent>
                          <Button
                            size="small"
                            variant="contained"
                            fullWidth
                            sx={{ mb: 1 }}
                            onClick={() => {
                              setExistingCatDlg(true);
                              setManageCatDlg(false);
                            }}
                          >
                            {translate5(
                              "Add Subcategory under existing category"
                            )}
                          </Button>
                          <Button
                            size="small"
                            variant="contained"
                            fullWidth
                            color="warning"
                            onClick={() => {
                              setAddCatDlg(true);
                              setManageCatDlg(false);
                            }}
                          >
                            {translate5("add subcategory with new category")}
                          </Button>
                        </DialogContent>
                        <DialogActions>
                          <Button
                            onClick={() => setManageCatDlg(false)}
                            color="error"
                          >
                            {translate5("Close")}
                          </Button>
                        </DialogActions>
                      </Dialog>
                      {/* Manage Existing Sub Category/ Category */}
                      <Dialog
                        open={existingCatDlg}
                        onClose={() => setExistingCatDlg(false)}
                        fullWidth
                        maxWidth={"lg"}
                      >
                        <DialogContent>
                          <ManageMedicineCategory />
                        </DialogContent>
                        <DialogActions>
                          <Button
                            onClick={() => setExistingCatDlg(false)}
                            color="error"
                          >
                            {translate5("Close")}
                          </Button>
                        </DialogActions>
                      </Dialog>
                    </Grid>
                  </Grid>
                </Grid>
              )}

              <Grid item xs={12}>
                <Grid container alignItems="center">
                  <Grid item xs={12} sm={6} md={4} lg={3}>
                    <FormControl size="small" fullWidth sx={{ mt: 1, pr: 2 }}>
                      <InputLabel id="select-availability">
                        {translate0("Availability")}
                      </InputLabel>
                      <Select
                        labelId="select-availability"
                        id="select-availability"
                        value={availability}
                        label={translate0("Availability")}
                        onChange={(e) => {availabilityTouched.current=true;setAvailability(e.target.value);}}
                      >
                        <MenuItem value={0}>{translate0("Available")}</MenuItem>
                        <MenuItem value={1}>
                          {translate0("Available Upon Inquiry")}
                        </MenuItem>
                        <MenuItem value={2}>
                          {translate0("Not Available")}
                        </MenuItem>
                      </Select>
                    </FormControl>
                  </Grid>
                  <Grid item xs={12} sm={6} md={4} lg={3}>
                    <FormControlLabel
                      disabled={fieldDisabled}
                      control={
                        <Checkbox
                          checked={visible}
                          onChange={(e) => setVisible(e.target.checked)}
                          color="success"
                        />
                      }
                      label={translate1("Visible")}
                    />
                  </Grid>

                  <Grid item xs={12} sm={6} md={4} lg={3}>
                    <FormControlLabel
                      disabled={fieldDisabled}
                      control={
                        <Checkbox
                          checked={prescribed}
                          onChange={(e) => setPrescribed(e.target.checked)}
                          color="error"
                        />
                      }
                      label={translate1("Prescribed")}
                    />
                  </Grid>
                  <Grid item xs={12} sm={6} md={4} lg={3}>
                    <FormControlLabel
                      disabled={fieldDisabled}
                      control={
                        <Checkbox
                          checked={topSeller}
                          onChange={(e) => setTopSeller(e.target.checked)}
                          color="info"
                        />
                      }
                      label={
                        <Typography
                          variant="subtitle1"
                          color={fieldDisabled ? "gray" : "initial"}
                        >
                          Most Popular
                          {!fieldDisabled && (
                            <InfoTut img="tut_best_seller.png" />
                          )}
                        </Typography>
                      }
                    />
                  </Grid>
                  <Grid item xs={12} sm={6} md={4} lg={3}>
                    <FormControlLabel
                      disabled={fieldDisabled}
                      control={
                        <Checkbox
                          checked={dealOfTheWeek}
                          onChange={(e) => setDealOfTheWeek(e.target.checked)}
                          color="error"
                        />
                      }
                      label={
                        <Typography
                          variant="subtitle1"
                          color={fieldDisabled ? "gray" : "initial"}
                        >
                          Featured Treatment
                          {!fieldDisabled && <InfoTut img="tut_deals.png" />}
                        </Typography>
                      }
                    />
                  </Grid>
                  <Grid item xs={12} sm={6} md={4} lg={3}>
                    <FormControlLabel
                      disabled={fieldDisabled}
                      control={
                        <Checkbox
                          checked={isNew}
                          onChange={(e) => setIsNew(e.target.checked)}
                          color="warning"
                        />
                      }
                      label={
                        <Typography
                          variant="subtitle1"
                          color={fieldDisabled ? "gray" : "initial"}
                        >
                          Latest Upload
                          {!fieldDisabled && <InfoTut img="tut_new_med.png" />}
                        </Typography>
                      }
                    />
                  </Grid>
                  <Grid item xs={12} sm={6} md={4} lg={3}>
                    <FormControlLabel
                      disabled={fieldDisabled}
                      control={
                        <Checkbox
                          checked={stock}
                          onChange={(e) => setStock(e.target.checked)}
                          color="secondary"
                        />
                      }
                      label={translate1("In Stock")}
                    />
                  </Grid>
                  {stock && (
                    <Grid item xs={12}>
                      <Grid container spacing={0} alignItems="flex-end">
                        <Grid item>
                          <Tooltip
                            arrow
                            title="Keep it at 0 to keep it hidden from the user"
                            placement="right"
                          >
                            <IconButton>
                              <InfoIcon
                                color={fieldDisabled ? "inherit" : "info"}
                              />
                            </IconButton>
                          </Tooltip>
                        </Grid>
                        <Grid item sx={{ flexGrow: 1 }}>
                          <TextField
                            label={translate1("Stock Count")}
                            type="text"
                            value={stockCount}
                            onChange={handleStockCount}
                            variant="outlined"
                            disabled={fieldDisabled}
                            fullWidth
                          />
                        </Grid>
                      </Grid>
                    </Grid>
                  )}
                </Grid>
              </Grid>
            </>
          )}
            </Grid>
            </MedicineFormSection>
          </Grid>
          {!englishVariantLoading && (
            <>
          {/* Variations */}
          <Grid item xs={12}>
            <MedicineFormSection sectionId="medicine-variations" icon={<TuneIcon />} title={translate1("Variations")}>
              <Button
                variant="contained"
                size="small"
                fullWidth
                color="warning"
                startIcon={<AddIcon />}
                onClick={handleAddVariation}
                disabled={fieldDisabled}
                sx={{ mb: addVariantSection > 0 ? 2 : 0 }}
              >
                {translate1("Add Variation")}
              </Button>
              <Grid container spacing={2.5}>
              {addVariantSection > 0 &&
                [...Array(addVariantSection)].map((x, i) => (
                  <Grid item xs={12} key={i}>
                  <Box
                    sx={{
                      border: `1px solid ${colors.line}`,
                      borderRadius: radii.md,
                      bgcolor: colors.paperTint,
                      p: 2,
                    }}
                  >
                  <Grid container spacing={2.5}>
                    <Grid item xs={12}>
                      <Button
                        variant="contained"
                        size="small"
                        fullWidth
                        color="error"
                        startIcon={<RemoveIcon />}
                        onClick={() => handleRemoveVariant(i)}
                      >
                        {translate1("Remove")}{" "}
                        {dosageForm[i] && `( ${getDosageName(dosageForm[i])} )`}
                      </Button>
                    </Grid>
                    <Grid item xs={12}>
                      <FormControlLabel
                        disabled={fieldDisabled}
                        control={
                          <Checkbox
                            checked={showInFront[i]}
                            onChange={(e) => handleShowInFront(e, i)}
                            color="success"
                          />
                        }
                        label="Show In Front-end"
                      />
                    </Grid>
                    <Grid item xs={12} sm={6}>
                      <Grid container spacing={0}>
                        <Grid item xs={11} xl={11.5}>
                          <Autocomplete
                            size="small"
                            onChange={(e, newValue) =>
                              handleDosageSelect(e, newValue, i)
                            }
                            value={dosageList.find(row=>(lang==='en'?row.fixedDosageId:row.dosageDetectorId)===dosageForm[i])||null}
                            isOptionEqualToValue={(option,value)=>option.fixedDosageId===value.fixedDosageId}
                            disablePortal
                            options={dosageList}
                            filterOptions={filterOptions}
                            filterSelectedOptions
                            getOptionLabel={(option) =>
                              `${option.dosageName} ${
                                lang !== "en"
                                  ? "(" + getEngDosage(option.dosageName) + ")"
                                  : ""
                              }`
                            }
                            renderOption={(props, option) => (
                              <Box
                                component="li"
                                sx={{
                                  "& > img": { mr: 2, flexShrink: 0 },
                                }}
                                {...props}
                              >
                                {option.dosageName}{" "}
                                {lang !== "en"
                                  ? "(" + getEngDosage(option.dosageName) + ")"
                                  : ""}
                              </Box>
                            )}
                            renderInput={(params) => (
                              <TextField
                                {...params}
                                label={translate1("Dosage Form")}
                                variant="outlined"
                                size="small"
                                fullWidth
                                required
                                error={
                                  lang !== "en" &&
                                  !fieldDisabled &&
                                  !dosageForm[i]
                                    ? true
                                    : false
                                }
                              />
                            )}
                          />
                        </Grid>
                        <Grid item xs={1} xl={0.25}>
                          <Tooltip
                            title={translate1("Dosage Form")}
                            arrow
                            placement="top"
                          >
                            <IconButton
                              size="small"
                              sx={{ mt: 1 }}
                              onClick={() => setAddDosageDlg(true)}
                            >
                              <AddCircleIcon color="success" />
                            </IconButton>
                          </Tooltip>
                          {addDosageDlg && (
                            <AddDosageDialog
                              addDosageDlg={addDosageDlg}
                              setAddDosageDlg={setAddDosageDlg}
                              lang={lang}
                            />
                          )}
                        </Grid>
                      </Grid>
                    </Grid>
                    <Grid item xs={12} sm={6}>
                      <TextField
                        label={translate1("Strength")}
                        value={strength[i]}
                        onChange={(e) => handleStrength(e, i)}
                        variant="outlined"
                        size="small"
                        fullWidth
                      />
                    </Grid>
                    <Grid item xs={12} sm={6}>

                          <TextField
                        label={translate1("Pack Types")}
                        value={packTypes[i]}
                        onChange={(e) => handlePackTypes(e, i)}
                        variant="outlined"
                        size="small"
                        fullWidth
                        error={
                          lang !== "en" && !fieldDisabled && !packTypes[i]
                            ? true
                            : false
                        }
                      />
                    </Grid>
                    <Grid item xs={12} sm={6}>
                      <TextField
                        label={translate1("Avg Price Of Originator")}
                        value={avgPriceOfOriginator[i]}
                        onChange={(e) => handleAvgPriceOfOriginator(e, i)}
                        variant="outlined"
                        size="small"
                        fullWidth
                      />
                    </Grid>
                    <Grid item xs={12} sm={3}>
                      <TextField
                        label={translate1("Selling Price")}
                        value={sellingPrice[i]}
                        onChange={(e) => handleSellingPrice(e, i)}
                        variant="outlined"
                        size="small"
                        fullWidth
                      />
                    </Grid>
                    <Grid item xs={12} sm={3}>
                      <TextField
                        label={translate0("Discount")}
                        value={discount[i]}
                        onChange={(e) => handleDiscount(e, i)}
                        variant="outlined"
                        size="small"
                        fullWidth
                      />
                    </Grid>
                    <Grid item xs={12} sm={6}>
                      <TextField
                        label={translate1("VIP Selling Price")}
                        value={vipSellingPrice[i]}
                        onChange={(e) => handleVipSellingPrice(e, i)}
                        variant="outlined"
                        size="small"
                        fullWidth
                      />
                    </Grid>
                    <Grid item xs={12} sm={6}>
                      <TextField
                        label={translate1("Company Patient Price Updated")}
                        value={companyPatientSellingPriceUpdated[i]}
                        onChange={(e) =>
                          handleCompanyPatientSellingPriceUpdated(e, i)
                        }
                        variant="outlined"
                        size="small"
                        fullWidth
                      />
                    </Grid>
                    <Grid item xs={12} sm={6}>
                      <TextField
                        label={translate1("Company Patient Price Old")}
                        value={companyPatientSellingPriceOld[i]}
                        onChange={(e) =>
                          handleCompanyPatientSellingPriceOld(e, i)
                        }
                        variant="outlined"
                        size="small"
                        fullWidth
                      />
                    </Grid>
                    <Grid item xs={12} sm={6}>
                      <TextField
                        label={translate1("Company Retail Price")}
                        value={companyMRP[i]}
                        onChange={(e) => handleCompanyMrp(e, i)}
                        variant="outlined"
                        size="small"
                        fullWidth
                      />
                    </Grid>
                    <Grid item xs={12} sm={3}>
                      <TextField
                        label={translate1("Minimum Order Qty")}
                        value={minimumOrderQty[i]}
                        onChange={(e) => handleMinimumOrderQty(e, i)}
                        variant="outlined"
                        size="small"
                        fullWidth
                      />
                    </Grid>
                    <Grid item xs={12} sm={3}>
                      <TextField
                        label={translate1("Weight (gram) Per Unit")}
                        value={weight[i]}
                        onChange={(e) => handleWeight(e, i)}
                        variant="outlined"
                        size="small"
                        fullWidth
                      />
                    </Grid>
                  </Grid>
                  </Box>
                  </Grid>
                ))}
              </Grid>
            </MedicineFormSection>
          </Grid>
          {/* SEO Section */}
          <Grid item xs={12}>
            <MedicineFormSection sectionId="medicine-seo" icon={<TravelExploreIcon />} title="SEO">
              <Grid container spacing={2.5}>
              <Grid item xs={12}>

                    <TextField
                  label={translate1("Meta Keyword")}
                  value={metaKeyword}
                  onChange={(e) => setMetaKeyword(e.target.value)}
                  variant="outlined"
                  size="small"
                  fullWidth
                  disabled={fieldDisabled}
                  multiline
                  required
                />
              </Grid>
              <Grid item xs={12}>

                    <TextField
                  label={translate1("Page Title")}
                  value={pageTitle}
                  onChange={(e) => setPageTitle(e.target.value)}
                  variant="outlined"
                  size="small"
                  fullWidth
                  multiline
                  disabled={fieldDisabled}
                  required
                  helperText={
                    <Typography
                      variant="body2"
                      color={pageTitle.length < 60 ? "primary" : "error"}
                      align="right"
                    >
                      {pageTitle.length}/60
                    </Typography>
                  }
                />
              </Grid>
              <Grid item xs={12}>

                    <TextField
                  label={translate1("Meta Title")}
                  value={metaTitle}
                  onChange={(e) => setMetaTitle(e.target.value)}
                  variant="outlined"
                  size="small"
                  fullWidth
                  disabled={fieldDisabled}
                  multiline
                  required
                  helperText={
                    <Typography
                      variant="body2"
                      color={metaTitle.length < 60 ? "primary" : "error"}
                      align="right"
                    >
                      {metaTitle.length}/60
                    </Typography>
                  }
                />
              </Grid>
              {!fieldDisabled && (
                <Grid item xs={12}>
                  <Grid
                    container
                    spacing={0}
                    justifyContent="space-between"
                    alignItems="center"
                  >
                    <Grid item xs={11} xl={11.75}>
                      <Autocomplete
                        disablePortal
                        multiple
                        value={tagList.filter(row => (tags || []).includes(lang === 'en' ? row.fixedId : row.tagDetectorId))}
                        isOptionEqualToValue={(a,b) => (lang === 'en' ? a.fixedId : a.tagDetectorId) === (lang === 'en' ? b.fixedId : b.tagDetectorId)}
                        disabled={fieldDisabled}
                        onChange={(e, newValue) => handleTags(e, newValue)}
                        options={tagList}
                        filterOptions={filterOptions}
                        getOptionLabel={(option) => option.tagName}
                        renderOption={(props, option) => (
                          <Box
                            component="li"
                            sx={{ "& > img": { mr: 2, flexShrink: 0 } }}
                            {...props}
                          >
                            {option.tagName}{" "}
                            {lang !== "en"
                              ? "(" + getEngTag(option.tagName) + ")"
                              : ""}
                          </Box>
                        )}
                        renderInput={(params) => (
                          <TextField
                            {...params}
                            label={translate1("Tags")}
                            size="small"
                            fullWidth
                          />
                        )}
                      />
                    </Grid>
                    <Grid item xs={1} xl={0.25}>
                      <Tooltip title="SEO" arrow placement="top">
                        <IconButton
                          size="small"
                          onClick={() => setAddTagDlg(true)}
                        >
                          <AddCircleIcon color="success" />
                        </IconButton>
                      </Tooltip>
                      <AddSeoTags
                        lang={lang}
                        addTagDlg={addTagDlg}
                        setAddTagDlg={setAddTagDlg}
                        tagListEn={tagListEn}
                      />
                    </Grid>
                  </Grid>
                </Grid>
              )}
              <Grid item xs={12}>

                    <TextField
                  label={translate1("Meta Description")}
                  value={metaDesc}
                  onChange={(e) => setMetaDesc(e.target.value)}
                  variant="outlined"
                  size="small"
                  multiline
                  minRows={3}
                  fullWidth
                  disabled={fieldDisabled}
                  required
                  helperText={
                    <Typography
                      variant="body2"
                      color={metaDesc.length < 151 ? "primary" : "error"}
                      align="right"
                    >
                      {metaDesc.length}/150
                    </Typography>
                  }
                />
              </Grid>

              </Grid>
            </MedicineFormSection>
          </Grid>
          {/* Additional Section */}
          <Grid item xs={12}>
            <MedicineFormSection sectionId="medicine-sections" icon={<ArticleIcon />} title={translate1("Additional Section")}>
              <Grid container spacing={2.5}>
              {!fieldDisabled && (
                <>
                  {/* File Upload */}
                  <Grid item xs={12}>
                    <FileUpload translate1={translate1} />
                  </Grid>

                  {/* Additional Section */}
                  <Grid item xs={12}>
                    <AdditionalPage
                      additionalSectionList={additionalSectionList}
                      setAdditionalSectionList={setAdditionalSectionList}
                          disabledEditor={formLoading}
                      translate1={translate1}
                          onTranslate={undefined}
                          disableTranslation={disableForm || formLoading}
                    />
                  </Grid>
                </>
              )}
              {additionalSectionPrompt && (
                <Grid item xs={12}>
                  <Grid container spacing={0}>
                    <Grid item xs={9} sm={10.5} md={11.25} xl={11.5}>
                      <TextField
                        label={translate1("Section Name")}
                        value={addSectionName}
                        onChange={(e) => setAddSectionName(e.target.value)}
                        fullWidth
                        required
                        size="small"
                        color="warning"
                        focused
                      />
                    </Grid>
                    <Grid item xs={3} sm={1.5} md={0.75} xl={0.5}>
                      <Grid container spacing={0}>
                        <Grid item>
                          <Tooltip
                            title={translate1("Confirm")}
                            arrow
                            placement="left"
                          >
                            <IconButton
                              size="small"
                              disabled={addSectionName !== "" ? false : true}
                              onClick={handleCreateAdditionalSection}
                            >
                              <CheckCircleIcon
                                color={
                                  addSectionName === "" ? "inherit" : "success"
                                }
                              />
                            </IconButton>
                          </Tooltip>
                        </Grid>
                        <Grid item>
                          <Tooltip title="Cancel" arrow placement="left">
                            <IconButton
                              size="small"
                              onClick={() => setAdditionalSectionPrompt(false)}
                            >
                              <CancelIcon color="error" />
                            </IconButton>
                          </Tooltip>
                        </Grid>
                      </Grid>
                    </Grid>
                  </Grid>
                </Grid>
              )}
              <Grid item xs={12} ref={additionalSectionBtnRef}>
                <Button
                  variant="contained"
                  size="small"
                  fullWidth
                  disabled={fieldDisabled || additionalSectionPrompt}
                  color="success"
                  startIcon={<AddIcon />}
                  onClick={() => {
                    setAdditionalSectionPrompt(!additionalSectionPrompt);
                    setTimeout(() => {
                      additionalSectionBtnRef.current.scrollIntoView({
                        behavior: "smooth",
                      });
                    }, 500);
                  }}
                >
                  {translate1("Additional Section")}
                </Button>
              </Grid>
              </Grid>
            </MedicineFormSection>
          </Grid>
            </>
          )}
        </Grid>
      </Box>
    </FullScreenFormDialog>
  );
}
